import {
  Snackbar,
  Alert, AlertTitle,
} from "@mui/material";

type Serverity = "success" | "info" | "warning" | "error";
interface MessageProps {
  messageText: string;
  messageSeverity: Serverity;
  messageOpen: boolean;
  setMessageOpen: React.Dispatch<React.SetStateAction<boolean>>;
}
function Message({ messageText, messageSeverity, messageOpen, setMessageOpen }: MessageProps): JSX.Element {

  return (
    <Snackbar
      message={messageText}
      open={messageOpen}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      autoHideDuration={
        (messageSeverity !== "success")
          ? null
          : 6000
      }
      onClose={() => setMessageOpen(false)}
    >
      <Alert
        severity={messageSeverity}
        onClose={() => setMessageOpen(false)}
      >
        <AlertTitle>
          {messageSeverity.toUpperCase()}
        </AlertTitle>
        {messageText}
      </Alert>
    </Snackbar>
  );
}

export default Message;
